'use strict';

/*
* Import components
 */
import initSentry from './components/sentry';
import initComponents from "./init";
import initGetUtmFromUrl from './components_split/_imports/loadMktoUtms';
import {
    getBreakpoint,
    outputBrowserNameHTMLtag,
    outputOSNameHTMLtag,
    initializeToolTips, debouncer
} from './utils/utils';
import {waitForDependencies} from "./components_split/_imports/utils/utils.common";

/*
* Initialize app
 */
waitForDependencies(() => {
    $(() => {
        initSentry();

        if(window.isRunningAds !== undefined) {
            document.body.classList.add("no-adBlocker");
        }

        outputBrowserNameHTMLtag();
        outputOSNameHTMLtag();
        initComponents();
        initializeToolTips();
        initGetUtmFromUrl();
        
        window.addEventListener('resize', debouncer(() => {
            global.breakpoint = getBreakpoint();
        }, 100));
    });
});